module.exports = __webpack_public_path__ + "static/media/shot_200831_115746.47dbf687.png";